export const ui = {
  nav: {
    home: { hi: 'होम', en: 'Home' },
    services: { hi: 'सेवाएँ', en: 'Services' },
    about: { hi: 'हमारे बारे में', en: 'About Us' },
    contact: { hi: 'संपर्क', en: 'Contact' },
  },
  hero: {
    tagline: { hi: 'हर खुशी को दीजिए डिजिटल पहचान', en: 'Give Every Happiness a Digital Identity' },
    tourLine: {
      hi: 'देश एवं विदेश के आकर्षक टूर पैकेज, धार्मिक यात्राएँ एवं विशेष यात्रा सुविधाएँ उपलब्ध',
      en: 'Attractive domestic & international tour packages, religious journeys & special travel facilities available'
    },
    searchPlaceholder: { hi: 'अपनी सेवा खोजें...', en: 'Search for a service...' },
    whatsapp: { hi: 'WhatsApp करें', en: 'WhatsApp Now' },
    callNow: { hi: 'अभी कॉल करें', en: 'Call Now' },
    allServices: { hi: 'सभी सेवाएँ देखें', en: 'View All Services' },
  },
  contact: {
    title: { hi: 'संपर्क करें', en: 'Contact Us' },
    address: { hi: 'पता', en: 'Address' },
    addressVal: { hi: '303, गोपुर एक्सटेंशन, गोपुर पुलिस चौकी के पास, इंदौर, म.प्र.', en: '303, Gopur Extension, Near Gopur Police Chowki, Indore, M.P.' },
    phone: { hi: 'मोबाइल', en: 'Mobile' },
    email: { hi: 'ईमेल', en: 'Email' },
    whatsapp: { hi: 'WhatsApp', en: 'WhatsApp' },
    enquiry: { hi: 'अभी पूछें', en: 'Enquire Now' },
  },
  footer: {
    tagline: { hi: 'हर खुशी को दीजिए डिजिटल पहचान', en: 'Give Every Happiness a Digital Identity' },
    quickLinks: { hi: 'त्वरित लिंक', en: 'Quick Links' },
    ourServices: { hi: 'हमारी सेवाएँ', en: 'Our Services' },
    social: { hi: 'सोशल मीडिया', en: 'Social Media' },
    legal: { hi: 'कानूनी', en: 'Legal' },
    privacy: { hi: 'गोपनीयता नीति', en: 'Privacy Policy' },
    terms: { hi: 'नियम व शर्तें', en: 'Terms & Conditions' },
    copy: { hi: 'सर्वाधिकार सुरक्षित', en: 'All Rights Reserved' },
  },
  splash: {
    enter: { hi: 'प्रवेश करें', en: 'Enter Website' },
    skip: { hi: 'छोड़ें', en: 'Skip' },
    voice: { hi: 'आवाज़ सुनें', en: 'Play Voice' },
    arth: { hi: 'अर्थात्', en: 'Meaning:' },
  },
};

export const serviceCategories = [
  {
    id: 'government',
    iconClass: 'fa-landmark',
    color: '#FFD700',
    accentColor: '#FF9933',
    titleHi: 'सरकारी सेवाएँ',
    titleEn: 'Government Services',
    descHi: 'PAN, आधार, पासपोर्ट, प्रमाण पत्र एवं सरकारी योजनाएँ',
    descEn: 'PAN, Aadhaar, Passport, Certificates & Govt Schemes',
    services: [
      { hi: 'PAN Card', en: 'PAN Card' },
      { hi: 'आधार Card', en: 'Aadhaar Card' },
      { hi: 'पासपोर्ट', en: 'Passport' },
      { hi: 'पासपोर्ट नवीनीकरण', en: 'Passport Renewal' },
      { hi: 'तत्काल पासपोर्ट', en: 'Tatkal Passport' },
      { hi: 'मतदाता पहचान पत्र', en: 'Voter ID' },
      { hi: 'जन्म प्रमाण पत्र', en: 'Birth Certificate' },
      { hi: 'मृत्यु प्रमाण पत्र', en: 'Death Certificate' },
      { hi: 'आय प्रमाण पत्र', en: 'Income Certificate' },
      { hi: 'जाति प्रमाण पत्र', en: 'Caste Certificate' },
      { hi: 'निवास प्रमाण पत्र', en: 'Residence Certificate' },
      { hi: 'आयुष्मान Card', en: 'Ayushman Card' },
      { hi: 'PM किसान', en: 'PM Kisan' },
      { hi: 'ई-श्रम Card', en: 'E-Shram Card' },
      { hi: 'पेंशन सेवाएँ', en: 'Pension Services' },
      { hi: 'छात्रवृत्ति सेवाएँ', en: 'Scholarship Services' },
      { hi: 'राशन Card', en: 'Ration Card' },
    ]
  },
  {
    id: 'rto',
    iconClass: 'fa-car',
    color: '#FF9933',
    accentColor: '#FFD700',
    titleHi: 'RTO सेवाएँ',
    titleEn: 'RTO Services',
    descHi: 'ड्राइविंग लाइसेंस, वाहन पंजीकरण एवं RTO कार्य',
    descEn: 'Driving Licence, Vehicle Registration & all RTO works',
    animated: 'car',
    services: [
      { hi: 'नया ड्राइविंग लाइसेंस', en: 'New Driving Licence' },
      { hi: 'लाइसेंस नवीनीकरण', en: 'Licence Renewal' },
      { hi: 'वाहन पंजीकरण', en: 'Vehicle Registration' },
      { hi: 'फिटनेस प्रमाण पत्र', en: 'Fitness Certificate' },
      { hi: 'परमिट सेवाएँ', en: 'Permit Services' },
      { hi: 'चॉइस नंबर', en: 'Choice Number' },
      { hi: 'VIP नंबर', en: 'VIP Number' },
      { hi: 'डुप्लीकेट RC', en: 'Duplicate RC' },
      { hi: 'वाहन NOC', en: 'Vehicle NOC' },
      { hi: 'स्वामित्व हस्तांतरण', en: 'Transfer of Ownership' },
      { hi: 'व्यावसायिक वाहन सेवाएँ', en: 'Commercial Vehicle Services' },
      { hi: 'बंधक सेवाएँ', en: 'Hypothecation Services' },
      { hi: 'सभी RTO संबंधित कार्य', en: 'All RTO Related Works' },
    ]
  },
  {
    id: 'business',
    iconClass: 'fa-briefcase',
    color: '#50C878',
    accentColor: '#FFD700',
    titleHi: 'व्यवसाय सेवाएँ',
    titleEn: 'Business Services',
    descHi: 'GST, ITR, MSME, ट्रेडमार्क एवं कंपनी पंजीकरण',
    descEn: 'GST, ITR, MSME, Trademark & Company Registration',
    services: [
      { hi: 'GST पंजीकरण', en: 'GST Registration' },
      { hi: 'GST रिटर्न', en: 'GST Return' },
      { hi: 'आयकर रिटर्न', en: 'Income Tax Return' },
      { hi: 'MSME पंजीकरण', en: 'MSME Registration' },
      { hi: 'ट्रेडमार्क पंजीकरण', en: 'Trademark Registration' },
      { hi: 'फर्म पंजीकरण', en: 'Firm Registration' },
      { hi: 'कंपनी पंजीकरण', en: 'Company Registration' },
      { hi: 'दुकान पंजीकरण', en: 'Shop Registration' },
      { hi: 'FSSAI लाइसेंस', en: 'FSSAI License' },
      { hi: 'व्यवसाय परामर्श', en: 'Business Consultancy' },
    ]
  },
  {
    id: 'insurance',
    iconClass: 'fa-shield-halved',
    color: '#D2042D',
    accentColor: '#FF4500',
    titleHi: 'बीमा सेवाएँ',
    titleEn: 'Insurance Services',
    descHi: 'स्वास्थ्य, जीवन, वाहन एवं यात्रा बीमा',
    descEn: 'Health, Life, Vehicle & Travel Insurance',
    services: [
      { hi: 'मेडिक्लेम बीमा', en: 'Mediclaim Insurance' },
      { hi: 'स्वास्थ्य बीमा', en: 'Health Insurance' },
      { hi: 'जीवन बीमा', en: 'Life Insurance' },
      { hi: 'वाहन बीमा', en: 'Vehicle Insurance' },
      { hi: 'यात्रा बीमा', en: 'Travel Insurance' },
      { hi: 'नवीनीकरण सेवाएँ', en: 'Renewal Services' },
      { hi: 'प्रीमियम भुगतान', en: 'Premium Payment Services' },
    ]
  },
  {
    id: 'travel',
    iconClass: 'fa-plane-departure',
    color: '#FF9933',
    accentColor: '#FFD700',
    titleHi: 'यात्रा सेवाएँ',
    titleEn: 'Travel Services',
    descHi: 'घरेलू, विदेशी, धार्मिक यात्राएँ एवं बुकिंग',
    descEn: 'Domestic, International, Religious tours & bookings',
    animated: 'plane',
    services: [
      { hi: 'देशीय टूर', en: 'Domestic Tours' },
      { hi: 'अंतर्राष्ट्रीय टूर', en: 'International Tours' },
      { hi: 'कस्टमाइज़ टूर पैकेज', en: 'Customized Tour Packages' },
      { hi: 'धार्मिक यात्राएँ', en: 'Religious Tours' },
      { hi: 'रेलवे बुकिंग', en: 'Railway Booking' },
      { hi: 'फ्लाइट बुकिंग', en: 'Flight Booking' },
      { hi: 'होटल बुकिंग', en: 'Hotel Booking' },
      { hi: 'टैक्सी बुकिंग', en: 'Taxi Booking' },
      { hi: 'बस बुकिंग', en: 'Bus Booking' },
    ]
  },
  {
    id: 'digital',
    iconClass: 'fa-palette',
    color: '#FF4500',
    accentColor: '#FF9933',
    titleHi: 'डिजिटल सेवाएँ',
    titleEn: 'Digital Services',
    descHi: 'निमंत्रण कार्ड, पोस्टर, लोगो एवं डिज़ाइन सेवाएँ',
    descEn: 'Invitation cards, posters, logos & all design services',
    services: [
      { hi: 'निमंत्रण कार्ड डिज़ाइन', en: 'Invitation Card Design' },
      { hi: 'शादी कार्ड डिज़ाइन', en: 'Wedding Card Design' },
      { hi: 'जन्मदिन निमंत्रण', en: 'Birthday Invitation Design' },
      { hi: 'त्योहार पोस्टर', en: 'Festival Poster Design' },
      { hi: 'लोगो डिज़ाइन', en: 'Logo Design' },
      { hi: 'बैनर डिज़ाइन', en: 'Banner Design' },
      { hi: 'विज़िटिंग कार्ड', en: 'Visiting Card Design' },
      { hi: 'लेटर पैड', en: 'Letter Pad Design' },
      { hi: 'ब्रोशर डिज़ाइन', en: 'Brochure Design' },
      { hi: 'प्रमाण पत्र डिज़ाइन', en: 'Certificate Design' },
      { hi: 'ID Card डिज़ाइन', en: 'ID Card Design' },
      { hi: 'सोशल मीडिया पोस्ट', en: 'Social Media Post Design' },
    ]
  },
  {
    id: 'video',
    iconClass: 'fa-clapperboard',
    color: '#D2042D',
    accentColor: '#FF9933',
    titleHi: 'वीडियो सेवाएँ',
    titleEn: 'Video Services',
    descHi: 'शादी, जन्मदिन, प्रमोशनल वीडियो एवं रील',
    descEn: 'Wedding, Birthday, Promotional videos & reels',
    services: [
      { hi: 'वीडियो निमंत्रण', en: 'Video Invitation' },
      { hi: 'शादी निमंत्रण वीडियो', en: 'Wedding Invitation Video' },
      { hi: 'जन्मदिन वीडियो', en: 'Birthday Video' },
      { hi: 'सालगिरह वीडियो', en: 'Anniversary Video' },
      { hi: 'त्योहार वीडियो', en: 'Festival Video' },
      { hi: 'बिज़नेस प्रमोशनल वीडियो', en: 'Business Promotional Video' },
      { hi: 'WhatsApp स्टेटस वीडियो', en: 'WhatsApp Status Video' },
      { hi: 'YouTube वीडियो एडिटिंग', en: 'YouTube Video Editing' },
      { hi: 'Reel एडिटिंग', en: 'Reel Editing' },
      { hi: 'Short वीडियो', en: 'Short Video Creation' },
    ]
  },
  {
    id: 'website',
    iconClass: 'fa-globe',
    color: '#50C878',
    accentColor: '#FFD700',
    titleHi: 'वेबसाइट एवं ऐप सेवाएँ',
    titleEn: 'Website & App Services',
    descHi: 'बिज़नेस वेबसाइट, ऐप डेवलपमेंट, होस्टिंग एवं डोमेन',
    descEn: 'Business website, app development, hosting & domain',
    services: [
      { hi: 'बिज़नेस वेबसाइट', en: 'Business Website' },
      { hi: 'WordPress वेबसाइट', en: 'WordPress Website' },
      { hi: 'eCommerce वेबसाइट', en: 'eCommerce Website' },
      { hi: 'Android App', en: 'Android App Development' },
      { hi: 'PWA डेवलपमेंट', en: 'PWA Development' },
      { hi: 'डोमेन सेटअप', en: 'Domain Setup' },
      { hi: 'होस्टिंग सेटअप', en: 'Hosting Setup' },
      { hi: 'Official Email', en: 'Official Email Setup' },
      { hi: 'वेबसाइट रखरखाव', en: 'Website Maintenance' },
    ]
  },
];

export const tickerItems = [
  'PAN Card', 'आधार Card', 'पासपोर्ट', 'Voter ID', 'GST Registration', 'ITR Filing',
  'Driving Licence', 'Vehicle Insurance', 'Wedding Video', 'Business Website',
  'Logo Design', 'Religious Tours', 'MSME Registration', 'Birth Certificate',
  'Ayushman Card', 'PM Kisan', 'Company Registration', 'Flight Booking',
  'Social Media Design', 'Android App', 'Trademark', 'E-Shram Card',
];

export const contact = {
  phone: '7869374752',
  whatsapp: '917869374752',
  email: 'Shriranjeetservices@gmail.com',
  addressHi: '303, गोपुर एक्सटेंशन, गोपुर पुलिस चौकी के पास, इंदौर, म.प्र.',
  addressEn: '303, Gopur Extension, Near Gopur Police Chowki, Indore, M.P.',
  mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58893.87!2d75.8065!3d22.7196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fcad1b410ddb%3A0x96ec4da356240f4!2sIndore%2C%20Madhya%20Pradesh!5e0!3m2!1sen!2sin!4v1700000000',
};
